<section class="main_section">
  <section *ngIf="!urlShared" class="top_layer">
    <div class="d-flex justify-content-between align-items-center w-100">
      <div class="left_container">

        <mat-icon (click)="goBack()">keyboard_arrow_left</mat-icon>
        <div (click)="goBack()" *ngIf="srcWidth > 475" class="d-flex align-items-center gap-2">
          <img
            alt=""
            class="logo" src="https://prod-simpo.s3.ap-south-1.amazonaws.com/prod-images/832957c1744700647885Group%201707481886.png"><span class="sec_top_layer">Simpo.ai</span>
        </div>
        <div class="page-dropdown whitebackgroundInput"
             style="background: #F5F5F5; border-radius: 10px; display: flex; padding-right: 10px; align-items: center;"
        >

          <select #pageSelect
                  (ngModelChange)="changePage()"
                  [(ngModel)]="currentPageId"
                  class="days_dropdown_"
                  style="border: none; outline: none; background: #F5F5F5;
                            appearance: none; -webkit-appearance: none; -moz-appearance: none;
                            height: 40px; padding: 0 10px; border-radius: 10px;
                            width:190px; font-weight:bold;">
            <option *ngFor="let item of templatePages" [value]="item.id">{{ item.pageName }}</option>
          </select>

          <img alt="" src="../../../assets/images/home_page/Vector.svg">

        </div>

      </div>
      <div *ngIf="srcWidth > 475" class="right_container flex-grow-1">

        <ng-container>
          <ng-template *ngTemplateOutlet="CustomizeActions"></ng-template>

          <div *ngIf="!staffId || !business.length" class="publish d-flex">
           
            <button (click)="signUp('PUBLISHED')" *ngIf="googleTokenId">Done</button>
          </div>

          <div *ngIf="staffId && business.length" class="btn-group publish" role="group">
            <button aria-expanded="false" class="dropdown-toggle publish_btn" data-toggle="dropdown"
                    type="button">
              Actions
            </button>
            <ul class="dropdown-menu" style="z-index: 10001;">
              <li><a (click)="createBusiness('PUBLISHED')"
                     class="dropdown-item cursor-pointer">Publish</a></li>
              <li><a (click)="createBusiness('NOT_PUBLISHED')"
                     class="dropdown-item cursor-pointer">Save</a></li>
            </ul>
          </div>
        </ng-container>
      </div>

      
      <ng-container *ngIf="srcWidth <= 475">
        <div class="d-flex justify-content-end">
          <button #container (click)="openRegeneratePopup()"
                  *ngIf="!colorPalletBoolean && !regenerateFontsBoolean" class="regenerate d-flex align-items-center justify-content-start gap-2"
                  style="background-color: lightblue;">
            <svg aria-hidden="true" class="icon h-5 w-5" fill="none" height="20" viewBox="0 0 24 24"
                 width="20" xmlns="http://www.w3.org/2000/svg">
              <path clip-rule="evenodd" d="M14.6152 1.59489c.3013.16794.4491.51968.3584.85241L12.982 9.74996h7.268c.2987 0 .5689.17719.6879.45114.119.2739.0642.5923-.1396.8106l-10.5 11.25c-.2353.2521-.61226.3113-.91349.1433-.30124-.1679-.44911-.5196-.35837-.8524L11.0181 14.25H3.75002c-.29865 0-.56884-.1772-.68786-.4511-.11903-.2739-.06421-.5923.13957-.8107L13.7017 1.73823c.2353-.25214.6123-.31128.9135-.14334Z"
                    fill="url(#grad1)"
                    fill-rule="evenodd"></path>
              <defs>
                <linearGradient id="grad1" x1="0%" x2="100%" y1="0%" y2="0%">
                  <stop offset="0%" stop-color="#283E90"/>
                  <stop offset="100%" stop-color="#F000E8"/>
                </linearGradient>
              </defs>
            </svg>
          </button>
          <div (click)="stopPropagation($event)"
               *ngIf="regenerateSection && !colorPalletBoolean && !regenerateFontsBoolean"
               class="regenerate-popup d-flex alig-items-center gap-2 justify-content-center">
            <button
              (click)="entireWebsiteRegenerate()"
              class="inside-regenerate-btns d-flex align-items-center gap-1 justify-content-start flex-column">
              <svg class="img" fill="none" height="25" viewBox="0 0 20 20" width="25"
                   xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M4.01108 19.9525C4.27565 20.0656 4.58327 19.9712 4.7378 19.7271L11.7691 8.55522C11.8829 8.3744 11.8898 8.14608 11.7868 7.95956C11.6838 7.77245 11.4869 7.65628 11.2735 7.65628H6.58085L8.32608 0.730146C8.39647 0.450341 8.25397 0.161357 7.98905 0.0474897C7.72585 -0.0657916 7.41628 0.0291694 7.26233 0.272919L0.231082 11.4448C0.117215 11.6256 0.11034 11.8539 0.213348 12.0405C0.316355 12.2276 0.513191 12.3437 0.726629 12.3437H5.41928L3.67405 19.2699C3.60366 19.5497 3.74612 19.8387 4.01108 19.9525Z"
                  fill="#000000"/>
              </svg>
              Entire website
            </button>
            <button
              (click)="openFonts()"
              class="inside-regenerate-btns d-flex align-items-center gap-1 justify-content-start flex-column">
              <svg aria-hidden="true" class="icon w-5 h-5" fill="none"
                   height="24" stroke="currentColor" viewBox="0 0 20 20" width="24" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.16667 5.83333c-.44203 0-.86595-.17559-1.17851-.48815C2.67559 5.03262 2.5 4.60869 2.5 4.16667c0-.44203.17559-.86595.48816-1.17851C3.30072 2.67559 3.72464 2.5 4.16667 2.5c.44202 0 .86595.17559 1.17851.48816.31256.31256.48815.73648.48815 1.17851M4.16667 5.83333c.44202 0 .86595-.17559 1.17851-.48815.31256-.31256.48815-.73649.48815-1.17851M4.16667 5.83333v8.33337M5.83333 4.16667h8.33337m0 0c0 .44202.1756.86595.4881 1.17851.3126.31256.7365.48815 1.1785.48815m-1.6666-1.66666c0-.44203.1756-.86595.4881-1.17851.3126-.31257.7365-.48816 1.1785-.48816.4421 0 .866.17559 1.1785.48816.3126.31256.4882.73648.4882 1.17851 0 .44202-.1756.86595-.4882 1.17851-.3125.31256-.7364.48815-1.1785.48815m0 0v8.33337m-9.99997 1.6666c0 .4421-.17559.866-.48815 1.1785-.31256.3126-.73649.4882-1.17851.4882-.44203 0-.86595-.1756-1.17851-.4882-.31257-.3125-.48816-.7364-.48816-1.1785 0-.442.17559-.8659.48816-1.1785.31256-.3125.73648-.4881 1.17851-.4881m1.66666 1.6666c0-.442-.17559-.8659-.48815-1.1785-.31256-.3125-.73649-.4881-1.17851-.4881m1.66666 1.6666h8.33337m0 0c0 .4421.1756.866.4881 1.1785.3126.3126.7365.4882 1.1785.4882.4421 0 .866-.1756 1.1785-.4882.3126-.3125.4882-.7364.4882-1.1785 0-.442-.1756-.8659-.4882-1.1785-.3125-.3125-.7364-.4881-1.1785-.4881m-1.6666 1.6666c0-.442.1756-.8659.4881-1.1785.3126-.3125.7365-.4881 1.1785-.4881M8.33333 8.33333h3.33337M10 11.6667V8.33333" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="1.5">
                </path>
              </svg>
              Fonts
            </button>
            <button
              (click)="openColor()"
              class="inside-regenerate-btns d-flex align-items-center gap-1 justify-content-start flex-column">
              <svg aria-hidden="true" class="icon w-5 h-5" fill="none"
                   height="25" stroke="currentColor" viewBox="0 0 20 20" width="25" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 17.5c-1.98912 0-3.89678-.7902-5.3033-2.1967C3.29018 13.8968 2.5 11.9891 2.5 10c0-1.98912.79018-3.89678 2.1967-5.3033S8.01088 2.5 10 2.5c4.1417 0 7.5 2.985 7.5 6.66667 0 .88333-.395 1.73163-1.0983 2.35663-.7034.625-1.6575.9767-2.6517.9767h-2.0833c-.3718-.006-.7349.1125-1.0316.3367-.2967.2241-.5099.541-.6057.9003-.09578.3593-.0687.7403.077 1.0824.1456.3421.4015.6257.7269.8056.1664.1535.2805.3553.3263.5771.0458.2217.021.4522-.071.6591-.0919.2068-.2464.3797-.4416.4943-.1953.1146-.4215.1651-.647.1445Z" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="1.5">
                </path>
                <path d="M6.25 8.75c0 .22101.0878.43298.24408.58926.15628.15628.36824.24407.58925.24407.22102 0 .43298-.08779.58926-.24407.15628-.15628.24408-.36825.24408-.58926 0-.22101-.0878-.43298-.24408-.58926-.15628-.15628-.36824-.24407-.58926-.24407-.22101 0-.43297.08779-.58925.24407C6.3378 8.31702 6.25 8.52899 6.25 8.75Zm3.33333-2.5c0 .22101.0878.43298.24408.58926.15628.15628.36829.24407.58929.24407.221 0 .4329-.08779.5892-.24407.1563-.15628.2441-.36825.2441-.58926 0-.22101-.0878-.43298-.2441-.58926-.1563-.15628-.3682-.24407-.5892-.24407-.221 0-.43301.08779-.58929.24407-.15628.15628-.24408.36825-.24408.58926Zm3.33337 2.5c0 .22101.0878.43298.244.58926.1563.15628.3683.24407.5893.24407.221 0 .433-.08779.5893-.24407.1562-.15628.244-.36825.244-.58926 0-.22101-.0878-.43298-.244-.58926-.1563-.15628-.3683-.24407-.5893-.24407-.221 0-.433.08779-.5893.24407-.1562.15628-.244.36825-.244.58926Z" stroke-linecap="round" stroke-linejoin="round"
                      stroke-width="1.5">
                </path>
              </svg>
              Colors
            </button>
          </div>

          <div (click)="createNewPage()"
               class="multi_page d-flex border"
               style="width: fit-content; border-radius: 5px;font-size: 14px; font-weight: 600;background-color: white; height: 37px;">
            <button class="button-style d-flex justify-content-center align-items-center"
                    style="border: none; border-radius: 5px;">
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </section>

  <!-- component Dynamic pickup section -->
  <section [ngClass]="urlShared ? 'full_bottom_layer' : 'bottom_layer'" class="bottom_layer">
    <ng-template #websiteStructure></ng-template>
  </section>


  <ng-container *ngIf="srcWidth < 475">
    <div #container class="regenerate-container">
      <button (click)="signUp('PUBLISHED')"
              *ngIf="!staffId || !business.length" class="regenerate d-flex align-items-center justify-content-start gap-2">
        <svg aria-hidden="true" class="icon w-5 h-5" fill="none" height="20" stroke="currentColor"
             viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.53086 16.1224C9.08517 15.0243 8.00801 14.25 6.75 14.25c-1.65685 0-3 1.3431-3 3 0 1.2426-1.00738 2.25-2.25002 2.25-.0507 0-.101-.0017-.15086-.005.77736 1.3478 2.23317 2.255 3.90086 2.255 2.47823 0 4.48856-2.0033 4.49995-4.4789.00005-.007.00007-.014.00007-.0211 0-.3988-.07783-.7795-.21914-1.1276Zm0 0c1.19434-.4071 2.33034-.9519 3.38664-1.6196m-5.0425-.0259c.4073-1.1972.9531-2.3358 1.62224-3.3944m3.42026 3.4203c1.8805-1.1887 3.5084-2.7666 4.7631-4.64874l3.876-5.814c.1261-.18913.1934-.41136.1934-.63867 0-.6359-.5155-1.15139-1.1514-1.15139-.2273 0-.4495.06729-.6387.19338l-5.814 3.87599c-1.8821 1.25476-3.46 2.88267-4.64866 4.76313m3.42026 3.4203c-.6779-1.5195-1.9008-2.7424-3.42026-3.4203" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="1.5">
          </path>
        </svg>
        Customize
      </button>
      <!-- Font Families -->
      <div *ngIf="regenerateFontsBoolean && !regenerateSection" class="font-families">
        <div (click)="closeFonts()" class="done-button">
          <img class="close-img" src="../../../assets/images/close.svg">
        </div>
        <ng-container *ngFor="let item of fontFamilies">
          <div (click)="selectedFontFamily(item)"
               class="card-height border rounded bg-white px-2 py-2 cursor-pointer">
            <div [style.fontFamily]="item?.headingFontValues?.fontFamily" class="font-title">
              {{ item.displayHeading }}
            </div>
            <div [style.fontWeight]="item?.bodyFontValues?.fontWeight" class="font-desc">
              {{ item.displayBody }}
            </div>
          </div>
        </ng-container>
      </div>

      <!-- Color Palettes -->
      <div *ngIf="colorPalletBoolean" class="regenerate-popup-color">
        <div (click)="closePalette()" class="done-button">
          <img class="close-img" src="../../../assets/images/close.svg">
        </div>
        <ng-container *ngFor="let theme of themes">
          <div (click)="selectTheme(theme)" class="palette">
            <div *ngFor="let style of theme.componentStyles; let i = index">
              <div [ngClass]="{ 'left-pallet-border': i === 0, 'right-pallet-border': i === 3 }" [ngStyle]="{'background-color' : style.bgColor}"
                   class="palette-card">
                <div class="button-text">
                  <div [ngStyle]="{'background-color' : style.accentColor}"
                       style="height: 10px; width: 10px;border-radius: 50%;"></div>
                  <p style="height: 10px; width: 15px; color: transparent;">Aa</p>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <div *ngIf="staffId || googleTokenId" class="signup-tab">
    <div *ngIf="srcWidth <= 475" [ngClass]="{'shaking-animation': needUserToLogin}" class="signupsection" style="flex-direction: row;gap: 30PX;
            align-items: center;
            width: 95%;">
      <div class="signUp-text" style="margin-bottom: 0; font-weight: bold;
            color: black;">
        Publish your website
      </div>
      <div class="signUp-btn">
        <button (click)="createBusiness('PUBLISHED')" *ngIf="!googleTokenId">Publish</button>
        <button (click)="signUp('PUBLISHED')" *ngIf="googleTokenId">Publish</button>
      </div>
    </div>
  </div>
</section>

<section *ngIf="successPage"
         class="success-page main_section d-flex align-items-center justify-content-center flex-column w-100">

  <div class="success-container">
    <div class="registartion-img d-flex alig-items-center justify-content-center mb-2">
      <svg class="lucide lucide-circle-check-big h-16 w-16 text-green-500" fill="none" height="85" stroke="rgb(34 ,197 ,94)" stroke-linecap="round"
           stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="60"
           xmlns="http://www.w3.org/2000/svg">
        <path d="M21.801 10A10 10 0 1 1 17 3.335"></path>
        <path d="m9 11 3 3L22 4"></path>
      </svg>
    </div>
    <div class="complete-text text-2xl font-bold text-gray-800 mb-1 text-center">Setup Completed!
    </div>
    <div class="tq-text text-gray-600 mb-8 text-center">
      Thank you for creating your business. Your website is now generated.
    </div>
  </div>
</section>


<div *ngIf="screenLoader" class="loading" id="animationLoader">
  <section class="loader_section">
    <!-- <app-loader [textLoop]="textsForScreenLoader"></app-loader> -->
    <app-website-loader></app-website-loader>
  </section>
</div>

<div *ngIf="pageLoader" class="loader">
  <section class="loader_section">
    <app-lottie-loader></app-lottie-loader>
  </section>
</div>
<!-- <div class="loading" *ngIf="poppperLoader" id="popperLoader">
    <app-lottie-poppper></app-lottie-poppper>
</div> -->

<ng-template #CustomizeActions>
  <div class="d-flex align-items-center customize-items">
    <div (click)="createNewPage()"
         class="multi_page d-flex border mr-20"
         style="width: fit-content; border-radius: 5px;font-size: 14px; font-weight: 600;background-color: white; height: 40px;">
      <button class="button-style d-flex justify-content-center align-items-center"
              style="border: none; border-radius: 5px;">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <div (click)="stopPropagation($event)"
         *ngIf="regenerateSection && !colorPalletBoolean && !regenerateFontsBoolean"
         class="regenerate-popup d-flex alig-items-center gap-2 flex-column justify-content-center">
      <button (click)="entireWebsiteRegenerate()"
              class="inside-regenerate-btns d-flex align-items-center gap-1 justify-content-start">
        <svg fill="none" height="24" viewBox="0 0 20 20" width="24" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.01108 19.9525C4.27565 20.0656 4.58327 19.9712 4.7378 19.7271L11.7691 8.55522C11.8829 8.3744 11.8898 8.14608 11.7868 7.95956C11.6838 7.77245 11.4869 7.65628 11.2735 7.65628H6.58085L8.32608 0.730146C8.39647 0.450341 8.25397 0.161357 7.98905 0.0474897C7.72585 -0.0657916 7.41628 0.0291694 7.26233 0.272919L0.231082 11.4448C0.117215 11.6256 0.11034 11.8539 0.213348 12.0405C0.316355 12.2276 0.513191 12.3437 0.726629 12.3437H5.41928L3.67405 19.2699C3.60366 19.5497 3.74612 19.8387 4.01108 19.9525Z"
            fill="#000000"/>
        </svg>
        <span class="window-titles">Entire website</span>
      </button>
      <button (click)="openColor()"
              class="inside-regenerate-btns d-flex align-items-center gap-1 justify-content-start">
        <svg aria-hidden="true" class="icon w-5 h-5" fill="none" height="24"
             stroke="currentColor" viewBox="0 0 20 20" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 17.5c-1.98912 0-3.89678-.7902-5.3033-2.1967C3.29018 13.8968 2.5 11.9891 2.5 10c0-1.98912.79018-3.89678 2.1967-5.3033S8.01088 2.5 10 2.5c4.1417 0 7.5 2.985 7.5 6.66667 0 .88333-.395 1.73163-1.0983 2.35663-.7034.625-1.6575.9767-2.6517.9767h-2.0833c-.3718-.006-.7349.1125-1.0316.3367-.2967.2241-.5099.541-.6057.9003-.09578.3593-.0687.7403.077 1.0824.1456.3421.4015.6257.7269.8056.1664.1535.2805.3553.3263.5771.0458.2217.021.4522-.071.6591-.0919.2068-.2464.3797-.4416.4943-.1953.1146-.4215.1651-.647.1445Z" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="1.5">
          </path>
          <path d="M6.25 8.75c0 .22101.0878.43298.24408.58926.15628.15628.36824.24407.58925.24407.22102 0 .43298-.08779.58926-.24407.15628-.15628.24408-.36825.24408-.58926 0-.22101-.0878-.43298-.24408-.58926-.15628-.15628-.36824-.24407-.58926-.24407-.22101 0-.43297.08779-.58925.24407C6.3378 8.31702 6.25 8.52899 6.25 8.75Zm3.33333-2.5c0 .22101.0878.43298.24408.58926.15628.15628.36829.24407.58929.24407.221 0 .4329-.08779.5892-.24407.1563-.15628.2441-.36825.2441-.58926 0-.22101-.0878-.43298-.2441-.58926-.1563-.15628-.3682-.24407-.5892-.24407-.221 0-.43301.08779-.58929.24407-.15628.15628-.24408.36825-.24408.58926Zm3.33337 2.5c0 .22101.0878.43298.244.58926.1563.15628.3683.24407.5893.24407.221 0 .433-.08779.5893-.24407.1562-.15628.244-.36825.244-.58926 0-.22101-.0878-.43298-.244-.58926-.1563-.15628-.3683-.24407-.5893-.24407-.221 0-.433.08779-.5893.24407-.1562.15628-.244.36825-.244.58926Z" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="1.5">
          </path>
        </svg>
        <span class="window-titles">Colors</span>
      </button>
      <button (click)="openFonts()"
              class="inside-regenerate-btns d-flex align-items-center gap-1 justify-content-start">
        <svg aria-hidden="true" class="icon w-5 h-5" fill="none" height="24"
             stroke="currentColor" viewBox="0 0 20 20" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.16667 5.83333c-.44203 0-.86595-.17559-1.17851-.48815C2.67559 5.03262 2.5 4.60869 2.5 4.16667c0-.44203.17559-.86595.48816-1.17851C3.30072 2.67559 3.72464 2.5 4.16667 2.5c.44202 0 .86595.17559 1.17851.48816.31256.31256.48815.73648.48815 1.17851M4.16667 5.83333c.44202 0 .86595-.17559 1.17851-.48815.31256-.31256.48815-.73649.48815-1.17851M4.16667 5.83333v8.33337M5.83333 4.16667h8.33337m0 0c0 .44202.1756.86595.4881 1.17851.3126.31256.7365.48815 1.1785.48815m-1.6666-1.66666c0-.44203.1756-.86595.4881-1.17851.3126-.31257.7365-.48816 1.1785-.48816.4421 0 .866.17559 1.1785.48816.3126.31256.4882.73648.4882 1.17851 0 .44202-.1756.86595-.4882 1.17851-.3125.31256-.7364.48815-1.1785.48815m0 0v8.33337m-9.99997 1.6666c0 .4421-.17559.866-.48815 1.1785-.31256.3126-.73649.4882-1.17851.4882-.44203 0-.86595-.1756-1.17851-.4882-.31257-.3125-.48816-.7364-.48816-1.1785 0-.442.17559-.8659.48816-1.1785.31256-.3125.73648-.4881 1.17851-.4881m1.66666 1.6666c0-.442-.17559-.8659-.48815-1.1785-.31256-.3125-.73649-.4881-1.17851-.4881m1.66666 1.6666h8.33337m0 0c0 .4421.1756.866.4881 1.1785.3126.3126.7365.4882 1.1785.4882.4421 0 .866-.1756 1.1785-.4882.3126-.3125.4882-.7364.4882-1.1785 0-.442-.1756-.8659-.4882-1.1785-.3125-.3125-.7364-.4881-1.1785-.4881m-1.6666 1.6666c0-.442.1756-.8659.4881-1.1785.3126-.3125.7365-.4881 1.1785-.4881M8.33333 8.33333h3.33337M10 11.6667V8.33333" stroke-linecap="round" stroke-linejoin="round"
                stroke-width="1.5">
          </path>
        </svg>
        <span class="window-titles">Fonts</span>
      </button>
      <!-- <button class="inside-regenerate-btns d-flex align-items-center gap-1 justify-content-start">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" width="24" height="24"
              class="icon w-5 h-5" aria-hidden="true">
              <path stroke="currentColor" stroke-linecap="round" stroke-width="1.5"
                  d="M11 12h7m-7-8h7m-7 4h7M2 16h16"></path>
              <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                  d="m2 12 .85714-2.28571M8 12l-.85714-2.28571m0 0L5 4 2.85714 9.71429m4.28572 0H2.85714">
              </path>
          </svg>
          Text
      </button> -->
    </div>
    <div *ngIf="colorPalletBoolean"
         class="regenerate-popup1 d-flex alig-items-center gap-2 flex-column justify-content-center">
      <div class="palette-header">
        <div class="palette-title">
          <svg aria-hidden="true" class="icon w-5 h-5 text-gray-700" fill="none" height="24"
               stroke="currentColor" viewBox="0 0 20 20" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 17.5c-1.98912 0-3.89678-.7902-5.3033-2.1967C3.29018 13.8968 2.5 11.9891 2.5 10c0-1.98912.79018-3.89678 2.1967-5.3033S8.01088 2.5 10 2.5c4.1417 0 7.5 2.985 7.5 6.66667 0 .88333-.395 1.73163-1.0983 2.35663-.7034.625-1.6575.9767-2.6517.9767h-2.0833c-.3718-.006-.7349.1125-1.0316.3367-.2967.2241-.5099.541-.6057.9003-.09578.3593-.0687.7403.077 1.0824.1456.3421.4015.6257.7269.8056.1664.1535.2805.3553.3263.5771.0458.2217.021.4522-.071.6591-.0919.2068-.2464.3797-.4416.4943-.1953.1146-.4215.1651-.647.1445Z" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.5">
            </path>
            <path d="M6.25 8.75c0 .22101.0878.43298.24408.58926.15628.15628.36824.24407.58925.24407.22102 0 .43298-.08779.58926-.24407.15628-.15628.24408-.36825.24408-.58926 0-.22101-.0878-.43298-.24408-.58926-.15628-.15628-.36824-.24407-.58926-.24407-.22101 0-.43297.08779-.58925.24407C6.3378 8.31702 6.25 8.52899 6.25 8.75Zm3.33333-2.5c0 .22101.0878.43298.24408.58926.15628.15628.36829.24407.58929.24407.221 0 .4329-.08779.5892-.24407.1563-.15628.2441-.36825.2441-.58926 0-.22101-.0878-.43298-.2441-.58926-.1563-.15628-.3682-.24407-.5892-.24407-.221 0-.43301.08779-.58929.24407-.15628.15628-.24408.36825-.24408.58926Zm3.33337 2.5c0 .22101.0878.43298.244.58926.1563.15628.3683.24407.5893.24407.221 0 .433-.08779.5893-.24407.1562-.15628.244-.36825.244-.58926 0-.22101-.0878-.43298-.244-.58926-.1563-.15628-.3683-.24407-.5893-.24407-.221 0-.433.08779-.5893.24407-.1562.15628-.244.36825-.244.58926Z" stroke-linecap="round" stroke-linejoin="round"
                  stroke-width="1.5">
            </path>
          </svg>
          <!-- <mat-icon>palette</mat-icon> -->
          Color Palette
        </div>
        <div (click)="closePalette()" class="done-button">
          <img class="close-img" src="../../../assets/images/close.svg">
        </div>
      </div>
      <hr class="section-divider">
      <ng-container *ngFor="let theme of themes">
        <div (click)="selectTheme(theme)" class="palette">
          <div *ngFor="let style of theme.componentStyles; let i = index" style="width: 25%;">
            <div [ngClass]="{ 'left-pallet-border': i === 0, 'right-pallet-border': i === 3 }" [ngStyle]="{'background-color' : style.bgColor}"
                 class="palette-card">
              <div class="button-text">
                <div [ngStyle]="{'background-color' : style.accentColor}"
                     style="height: 10px; width: 10px;border-radius: 50%;"></div>
                <p style="height: 10px; width: 10px;">Aa</p>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
    <div *ngIf="regenerateFontsBoolean"
         class="regenerate-popup d-flex alig-items-center gap-2 flex-column justify-content-center">
      <div class="palette-header">
        <div class="palette-title">
          <svg _ngcontent-hcr-c301="" aria-hidden="true" class="icon w-5 h-5" fill="none"
               height="24" stroke="currentColor" viewBox="0 0 20 20" width="24" xmlns="http://www.w3.org/2000/svg">
            <path _ngcontent-hcr-c301="" d="M4.16667 5.83333c-.44203 0-.86595-.17559-1.17851-.48815C2.67559 5.03262 2.5 4.60869 2.5 4.16667c0-.44203.17559-.86595.48816-1.17851C3.30072 2.67559 3.72464 2.5 4.16667 2.5c.44202 0 .86595.17559 1.17851.48816.31256.31256.48815.73648.48815 1.17851M4.16667 5.83333c.44202 0 .86595-.17559 1.17851-.48815.31256-.31256.48815-.73649.48815-1.17851M4.16667 5.83333v8.33337M5.83333 4.16667h8.33337m0 0c0 .44202.1756.86595.4881 1.17851.3126.31256.7365.48815 1.1785.48815m-1.6666-1.66666c0-.44203.1756-.86595.4881-1.17851.3126-.31257.7365-.48816 1.1785-.48816.4421 0 .866.17559 1.1785.48816.3126.31256.4882.73648.4882 1.17851 0 .44202-.1756.86595-.4882 1.17851-.3125.31256-.7364.48815-1.1785.48815m0 0v8.33337m-9.99997 1.6666c0 .4421-.17559.866-.48815 1.1785-.31256.3126-.73649.4882-1.17851.4882-.44203 0-.86595-.1756-1.17851-.4882-.31257-.3125-.48816-.7364-.48816-1.1785 0-.442.17559-.8659.48816-1.1785.31256-.3125.73648-.4881 1.17851-.4881m1.66666 1.6666c0-.442-.17559-.8659-.48815-1.1785-.31256-.3125-.73649-.4881-1.17851-.4881m1.66666 1.6666h8.33337m0 0c0 .4421.1756.866.4881 1.1785.3126.3126.7365.4882 1.1785.4882.4421 0 .866-.1756 1.1785-.4882.3126-.3125.4882-.7364.4882-1.1785 0-.442-.1756-.8659-.4882-1.1785-.3125-.3125-.7364-.4881-1.1785-.4881m-1.6666 1.6666c0-.442.1756-.8659.4881-1.1785.3126-.3125.7365-.4881 1.1785-.4881M8.33333 8.33333h3.33337M10 11.6667V8.33333" stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="1.5">
            </path>
          </svg>
          <!-- <mat-icon>fonts</mat-icon> -->
          Fonts
        </div>
        <div (click)="closeFonts()" class="done-button">
          <img class="close-img" src="../../../assets/images/close.svg">
        </div>
      </div>
      <hr class="section-divider">
      <div class="font-families">
        <ng-container *ngFor="let item of fontFamilies">
          <div (click)="selectedFontFamily(item)"
               class="border rounded bg-white px-2 py-2 cursor-pointer">
            <div [style.fontFamily]="item?.headingFontValues?.fontFamily" class="font-title">
              {{ item.displayHeading }}
            </div>
            <div [style.fontWeight]="item?.bodyFontValues?.fontWeight" class="font-desc">
              {{ item.displayBody }}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
    <div #container (click)="openRegeneratePopup()" class="regenerate-container">


      <img alt="" src="../../../assets/images/home_page/regenrate-icon3.svg" style="height: 14vh;">


    </div>
    <button (click)="signUp('PUBLISHED')" *ngIf="!staffId || !business.length"
            class="customize d-flex align-items-center justify-content-start gap-2">
      <svg aria-hidden="true" class="icon w-5 h-5" fill="none" height="20" stroke="currentColor"
           viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.53086 16.1224C9.08517 15.0243 8.00801 14.25 6.75 14.25c-1.65685 0-3 1.3431-3 3 0 1.2426-1.00738 2.25-2.25002 2.25-.0507 0-.101-.0017-.15086-.005.77736 1.3478 2.23317 2.255 3.90086 2.255 2.47823 0 4.48856-2.0033 4.49995-4.4789.00005-.007.00007-.014.00007-.0211 0-.3988-.07783-.7795-.21914-1.1276Zm0 0c1.19434-.4071 2.33034-.9519 3.38664-1.6196m-5.0425-.0259c.4073-1.1972.9531-2.3358 1.62224-3.3944m3.42026 3.4203c1.8805-1.1887 3.5084-2.7666 4.7631-4.64874l3.876-5.814c.1261-.18913.1934-.41136.1934-.63867 0-.6359-.5155-1.15139-1.1514-1.15139-.2273 0-.4495.06729-.6387.19338l-5.814 3.87599c-1.8821 1.25476-3.46 2.88267-4.64866 4.76313m3.42026 3.4203c-.6779-1.5195-1.9008-2.7424-3.42026-3.4203" stroke-linecap="round" stroke-linejoin="round"
              stroke-width="1.5">
        </path>
      </svg>
      Customize
    </button>

    <div *ngIf="srcWidth <= 475" class="dropdown">
      <div class="dropdown-toggle my-dropdown-toggle d-flex justify-content-center align-items-center"
           data-bs-toggle="dropdown">
        <img alt="" src="../../../assets/images/list-business/three_dots.svg">
      </div>

      <ul class="dropdown-menu dropdown-menu-dark bg-white">
        <li><a (click)="!staffId ? signUp('PUBLISHED') : createBusiness('PUBLISHED')"
               class="dropdown-item text-black d-flex align-items-center">
          <mat-icon
            class="me-2">publish
          </mat-icon>
          Publish</a></li>
        <li><a (click)="shareWebsite()" class="dropdown-item text-black d-flex align-items-center">
          <mat-icon
            class="me-2">share
          </mat-icon>
          Share</a></li>
      </ul>
    </div>
  </div>
</ng-template>

<div aria-labelledby="offcanvasBottomLabel" class="offcanvas offcanvas-bottom" id="offcanvasBottom" style="width: 100%;height: auto!important;"
     tabindex="-1">
  <div class="regenerate-top-header">
    <img alt="" class="regenerate-image" src="../../../assets/images/regeneratename.svg">
    <div aria-label="Close" class="close-bottom-sheet" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasBottom"
         id="closeRegenerateSheet">
      <mat-icon>close</mat-icon>
    </div>
  </div>
  <div class="ptb-20 regenerate-bottom">
    <div (click)="doneGlobalRegenerate()" class="entire-website">
      <img src="../../../assets/images/regenerate-website.svg"> <span>Entire Website</span>
    </div>
    <div class="entire-website">
      <img (click)="changeSiteStyle()" src="../../../assets/images/font-color.svg"> <span>Font & Colors</span>
    </div>
  </div>
</div>

<div aria-labelledby="addPageBottomSheetLabel" class="offcanvas offcanvas-bottom page-bottom-sheet" id="addPageBottomSheet"
     style="width: 100%;height: auto!important;" tabindex="-1">
  <div class="heading_section">
    <div class="heading">
      Page
    </div>
    <div aria-label="Close" class="closing_bar" data-bs-dismiss="offcanvas" data-bs-target="#addPageBottomSheet">
      <mat-icon>close</mat-icon>
    </div>
  </div>
  <div class="hr_line"></div>
  <div *ngFor="let page of templatePages;let i = index">
    <div class="heading_section">
      <div class="heading">
        {{ page.pageName }}
      </div>
      <div class="done_btn">
        <button (click)="deletePage()" *ngIf="page.pageName != 'Home'"
                class="home-icon">
          <mat-icon>delete</mat-icon>
        </button>
        <button (click)="openEditor()" class="home-icon">
          <mat-icon>settings</mat-icon>
        </button>
      </div>
    </div>
  </div>
  <div class="button-parent">
    <button aria-label="Close" class="cancel-button" data-bs-dismiss="offcanvas"
            data-bs-target="#addPageBottomSheet" id="closeaddPageBottomSheet">Cancel
    </button>
    <!-- <button class="add-new-page" (click)="pageSelectionChange({})">Add New Page</button> -->
  </div>
</div>
